export enum Navigate {
  HomeScreen = "/",
  PrivacyPolicyScreen = "/privacy_policy",
  TNCScreen = "/terms_and_conditions",
  RefundPolicy = "/refund_and_cancellation",
  Contact = "/contact",
  TradingView = "/tradingview",
}
